export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePassword = (password: string): { valid: boolean; error?: string } => {
  if (password.length < 8) {
    return { valid: false, error: "Пароль должен содержать минимум 8 символов" };
  }
  if (!/[A-Z]/.test(password)) {
    return { valid: false, error: "Пароль должен содержать хотя бы одну заглавную букву" };
  }
  if (!/[a-z]/.test(password)) {
    return { valid: false, error: "Пароль должен содержать хотя бы одну строчную букву" };
  }
  if (!/[0-9]/.test(password)) {
    return { valid: false, error: "Пароль должен содержать хотя бы одну цифру" };
  }
  return { valid: true };
};

export const validateFullname = (fullname: string): { valid: boolean; error?: string } => {
  if (fullname.trim().length < 2) {
    return { valid: false, error: "Имя должно содержать минимум 2 символа" };
  }
  if (fullname.trim().length > 128) {
    return { valid: false, error: "Имя не должно превышать 128 символов" };
  }
  return { valid: true };
};
